<template>
  <div class="dropleft">
    <button
      type="button"
      data-toggle="dropdown"
      aria-haspopup="true"
      aria-expanded="false"
      style="width: 100%; height: 33px; position: absolute; z-index: 1; border: none; background: transparent"
    ></button>
    <div class="dropdown-menu">
      <a class="dropdown-item pt-0" href="#"
        ><div v-if="PROFILE" class="cd-user-menu__list-item">
          <a :href="PROFILE" target="_blank">{{ $t("userSideMenuV1.myProfile") }}</a>
        </div></a
      >
      <a class="dropdown-item pt-0" href="#">
        <div v-if="NOTIFICATIONS" class="cd-user-menu__list-item">
          <a :href="NOTIFICATIONS">{{ $t("userSideMenuV1.notifications") }}</a>
        </div></a
      >
      <div class="dropdown-divider pt-0" v-if="cdOrganisationAvailable"></div>
      <a class="dropdown-item pt-0" href="#">
        <div class="dropdown-header" @click.prevent v-if="cdOrganisationAvailable">
          {{ $t("userSideMenuV1.switchTo") }}
        </div></a
      >
      <a class="dropdown-item" href="#">
        <div v-if="cdUserAvailable && cdOrganisationAvailable" class="cd-user-menu__list-item">
          <a
            v-for="tenant in otherTenants"
            :key="tenant.tenantId"
            class="dropdown-item pl-5"
            href="#"
            @click.prevent="switchToTenant(tenant.tenantId)"
            >{{ tenant.tenantShortName }}</a
          >
        </div></a
      >
      <div class="dropdown-divider"></div>
      <a class="dropdown-item pt-0" href="#">
        <div v-if="DOCS" class="cd-user-menu__list-item">
          <a :href="DOCS">{{ $t("userSideMenuV1.help") }}</a>
        </div></a
      >
      <a class="dropdown-item pt-0" href="#">
        <div v-if="SUPPORT_MAILTO" class="cd-user-menu__list-item">
          <a :href="'mailto://' + SUPPORT_MAILTO">{{ $t("userSideMenuV1.support") }}</a>
        </div></a
      >
      <a class="dropdown-item pt-0" href="#">
        <div v-if="SUGGESTIONS" class="cd-user-menu__list-item">
          <a :href="SUGGESTIONS">{{ $t("userSideMenuV1.haveYourSay") }}</a>
        </div></a
      >
      <a class="dropdown-item pt-0" href="#">
        <div v-if="POLICIES" class="cd-user-menu__list-item">
          <a :href="POLICIES">{{ $t("userSideMenuV1.legalPrivacyCookies") }}</a>
        </div></a
      >
      <div class="dropdown-divider"></div>
      <a class="dropdown-item pt-0" href="#"
        ><div class="cd-user-menu__list-item">
          <a href="#" @click.prevent="logout">
            <font-awesome-icon icon="sign-out-alt"></font-awesome-icon>{{ $t("userSideMenuV1.logout") }}</a
          >
        </div></a
      >
    </div>
  </div>
</template>
<script lang="ts">
import { AppModule } from "@/core/store/modules/app-module";
import { User } from "oidc-client";
import { ICDOrganisationDto, ICDUserDto, IOrganisationTenantDto } from "@/core/models/CDIdentityModels";
import { CDIdentityModule } from "@/core/store/modules/cd-identity-module";
import isEmpty from "lodash/isEmpty";
import get from "lodash/get";
import getEnv from "@/core/utils/env";
import { oidcChannel } from "@/core/broadcast/broadcast";
import { defineComponent } from "vue";
import { useRouter } from "vue-router";

export default defineComponent({
  name: "UserSideMenuV1",
  props: {
    id: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      router: useRouter()
    };
  },
  computed: {
    PROFILE(): string {
      return getEnv("VUE_APP_CD_PLATFORM_PROFILE");
    },
    NOTIFICATIONS(): string {
      return getEnv("VUE_APP_CD_PLATFORM_NOTIFICATIONS");
    },
    DOCS(): string {
      return getEnv("VUE_APP_CD_PLATFORM_DOCS");
    },
    SUPPORT_MAILTO(): string {
      return getEnv("VUE_APP_CD_PLATFORM_SUPPORT_MAILTO");
    },
    SUGGESTIONS(): string {
      return getEnv("VUE_APP_CD_PLATFORM_SUGGESTIONS");
    },
    POLICIES(): string {
      return getEnv("VUE_APP_CD_PLATFORM_POLICIES");
    },
    currentUser(): string {
      return AppModule.config.currentUser?.name ?? "";
    },
    oidcUser(): User | null {
      return (this as any).$store.getters.oidcUser;
    },
    cdUser(): ICDUserDto {
      return CDIdentityModule.cdUser;
    },
    cdUserAvailable(): boolean {
      return !isEmpty(this.cdUser);
    },
    cdOrganisation(): ICDOrganisationDto {
      return CDIdentityModule.cdOrganisation;
    },
    cdOrganisationAvailable(): boolean {
      return !isEmpty(this.cdOrganisation);
    },
    otherTenants(): IOrganisationTenantDto[] {
      const cdTenantId = get(this.oidcUser, "cd_tenant_id", "");
      return this.cdOrganisation.tenants.filter(
        x => x.tenantId != cdTenantId && x.applicationId == getEnv("VUE_APP_IDENTITY_APPLICATION_ID")
      );
    },
    cdUserPhoto(): string {
      return CDIdentityModule.cdUser?.photoBase64 || "";
    }
  },
  methods: {
    async switchToTenant(tenantId: string): Promise<void> {
      const accountType = (this.oidcUser as any)["cd_account_type"] ?? "";
      await this.router.push({
        name: "ActivateTenant",
        params: {
          organisationId: this.cdOrganisation.id,
          tenantId: tenantId,
          accountType: accountType
        }
      });
    },

    async logout(): Promise<void> {
      (this as any).$store.commit("SET_MODE", 2);
      await (this as any).$store
        .dispatch("signOutOidc", {
          post_logout_redirect_uri: getEnv("VUE_APP_BASE_WEB")
        })
        .then(() => {
          oidcChannel.postMessage("logout-triggered");
        })
        .catch(async () => {
          await this.router.push({ name: "AuthenticationError" });
        });
    }
  }
});
</script>
<style scoped>
.btn {
  color: transparent;
}
.dropleft .dropdown-menu {
  top: 44px !important;
  right: 0% !important;
}
.cd-user-menu__list-item {
  padding: 0.5rem !important;
}
.btn:hover {
  color: transparent !important;
}
a {
  color: #2069b1;
  text-decoration: none;
}
</style>
